export default "__VITE_ASSET__$fKtdMES__"